<form [formGroup]="generalForm">
  <div style="padding: 0px 0px 10px 10px">
    <div class="flex flex-column" style="padding: 5px 5px">
      <span class="Title">Gestión de Créditos</span>
      <span class="SubTitle" style="margin-top: 15px">Valor de Créditos</span>
      <span class="ContentText"
        >Precio actual al que Compras Créditos a tu proveedor y Vendes a tus
        Players.</span
      >
      <div class="flex flex-column" style="margin-top: 10px; width: 300px">
        <span class="LabelText disabledLabel" style="margin-bottom: 5px"
          >Valor de Crédito</span
        >
        <p-skeleton
          *ngIf="showLoadSkeleton"
          shape="rectangle"
          height="2.5rem"
        ></p-skeleton>

        <div
          *ngIf="!showLoadSkeleton"
          class="p-inputtext p-disabled labelDisabled disabledInput disabledLabel"
        >
          <span class="p-inputtext">
            {{
              generalForm.get("credit_sell_value")?.value
                | currencyFormat
                  : {
                      currencyCode: currencyCode,
                      currencySymbol: currencySymbol,
                      credit: false,
                      currencyRegional: currencyRegional
                    }
            }}
          </span>
        </div>
      </div>
    </div>
    <p-divider></p-divider>
    <div class="flex flex-column" style="padding: 5px 5px">
      <div class="flex flex-column" style="margin-bottom: 5px">
        <span class="SubTitle">Venta de Créditos</span>
        <span class="ContentText"
          >Aquí podrás definir los montos mínimos y máximos de Ventas de
          Créditos que podrás registrar a los Players del Casino</span
        >
      </div>

      <div class="flex flex-column" style="margin-bottom: 5px">
        <div class="flex flex-column" style="margin-top: 10px; width: 300px">
          <span class="LabelText" style="margin-bottom: 5px">Venta Mínima</span>
          <p-skeleton
            *ngIf="showLoadSkeleton"
            shape="rectangle"
            height="2.5rem"
          ></p-skeleton>
          <p-inputNumber
            *ngIf="!showLoadSkeleton"
            formControlName="credit_minimum_sell"
            [min]="0"
            [step]="1"
            suffix=" Créditos"
            [showButtons]="true"
            (ngModelChange)="changeSelect()"
          >
          </p-inputNumber>
          <small
            *ngIf="generalForm.controls['credit_minimum_sell'].hasError('min')"
            class="p-error block"
            >Venta minima requiere un numero mayor a 0</small
          >
        </div>
      </div>

      <div class="flex flex-column" style="margin-bottom: 5px">
        <div class="flex flex-column" style="margin-top: 10px; width: 300px">
          <span class="LabelText" style="margin-bottom: 5px">Venta Máxima</span>
          <p-skeleton
            *ngIf="showLoadSkeleton"
            shape="rectangle"
            height="2.5rem"
          ></p-skeleton>
          <p-inputNumber
            *ngIf="!showLoadSkeleton"
            formControlName="credit_maximum_sell"
            [min]="0"
            [step]="1"
            suffix=" Créditos"
            [showButtons]="true"
            (ngModelChange)="changeSelect()"
          >
          </p-inputNumber>
          <small
            *ngIf="generalForm.controls['credit_maximum_sell'].hasError('min')"
            class="p-error block"
            >Venta maxima requiere un numero mayor a 0</small
          >
        </div>
      </div>
      <div class="row mt-2">
        <p-checkbox
          formControlName="sendemail_when_sell"
          inputId="ny"
          value="false"
          [binary]="true"
          (ngModelChange)="changeSelect()"
        ></p-checkbox>
        <label class="ml-1" for="ny"
          >Notificar por correo al realizar una venta</label
        >
      </div>
    </div>
    <p-divider></p-divider>

    <div class="flex flex-column" style="padding: 5px 5px">
      <div class="flex flex-column" style="margin-bottom: 5px">
        <span class="SubTitle">Retiro de Créditos</span>
        <span class="ContentText"
          >Aquí podrás definir los montos mínimos y máximos de Retiros de
          Créditos que podrás registrar a los Players del Casino.</span
        >
      </div>

      <div class="flex flex-column" style="margin-bottom: 5px">
        <div class="flex flex-column" style="margin-top: 10px; width: 300px">
          <span class="LabelText" style="margin-bottom: 5px"
            >Retiro Mínimo</span
          >
          <p-skeleton
            *ngIf="showLoadSkeleton"
            shape="rectangle"
            height="2.5rem"
          ></p-skeleton>
          <p-inputNumber
            *ngIf="!showLoadSkeleton"
            formControlName="credit_minimum_withdraw"
            [min]="0"
            [step]="1"
            suffix=" Creditos"
            [showButtons]="true"
            (ngModelChange)="changeSelect()"
          >
          </p-inputNumber>
          <small
            *ngIf="
              generalForm.controls['credit_minimum_withdraw'].hasError('min')
            "
            class="p-error block"
            >Retiro minimo requiere un numero mayor a 0</small
          >
        </div>
      </div>

      <div class="flex flex-column" style="margin-bottom: 5px">
        <div class="flex flex-column" style="margin-top: 10px; width: 300px">
          <span
            class="LabelText"
            style="margin-bottom: 5px"
            [ngClass]="{
              disabledLabel: generalForm.get('without_credit_limit')?.value
            }"
            >Retiro Máximo</span
          >
          <p-skeleton
            *ngIf="showLoadSkeleton"
            shape="rectangle"
            height="2.5rem"
          ></p-skeleton>
          <p-inputNumber
            *ngIf="
              !generalForm.get('without_credit_limit')?.value &&
              !showLoadSkeleton
            "
            formControlName="credit_maximum_withdraw"
            [min]="0"
            [step]="1"
            suffix=" Créditos"
            [showButtons]="true"
            (ngModelChange)="changeSelect()"
          >
          </p-inputNumber>
          <small
            *ngIf="
              generalForm.controls['credit_maximum_withdraw'].hasError('min') &&
              !generalForm.get('without_credit_limit')?.value
            "
            class="p-error block"
            >Retiro minimo requiere un numero mayor a 0</small
          >
          <input
            *ngIf="generalForm.get('without_credit_limit')?.value"
            type="text"
            pInputText
            value="Sin límite"
            disabled
          />
        </div>
        <div class="row mt-2">
          <p-checkbox
            formControlName="sendemail_when_withdraw"
            inputId="ny"
            value="false"
            [binary]="true"
            (ngModelChange)="changeSelect()"
          ></p-checkbox>
          <label class="ml-1" for="ny"
            >Notificar por correo al realizar un retiro</label
          >
        </div>
        <div class="row mt-2">
          <p-checkbox
            formControlName="without_credit_limit"
            inputId="ny"
            value="false"
            [binary]="true"
            (ngModelChange)="changeSelect()"
          ></p-checkbox>
          <label class="ml-1" for="ny">Sin límite de retiro</label>
        </div>
      </div>
    </div>
    <p-divider></p-divider>

    <div class="flex flex-column" style="padding: 5px 5px">
      <div class="flex flex-column" style="margin-bottom: 5px">
        <span class="SubTitle">Bono de Créditos</span>
        <span class="ContentText"
          >Aquí podrás definir el monto máximo de Abonos de Créditos que podrás
          registrar a los Players del Casino.</span
        >
      </div>

      <div class="flex flex-column" style="margin-bottom: 25px">
        <div class="flex flex-column" style="margin-top: 10px; width: 300px">
          <span class="LabelText" style="margin-bottom: 5px">Abono Máximo</span>
          <p-skeleton
            *ngIf="showLoadSkeleton"
            shape="rectangle"
            height="2.5rem"
          ></p-skeleton>
          <p-inputNumber
            *ngIf="!showLoadSkeleton"
            formControlName="bonus_maximum_sell"
            [min]="0"
            [step]="1"
            suffix=" Creditos"
            [showButtons]="true"
            (ngModelChange)="changeSelect()"
          >
          </p-inputNumber>
          <small
            *ngIf="generalForm.controls['bonus_maximum_sell'].hasError('min')"
            class="p-error block"
            >Abono máximo requiere un numero mayor a 0</small
          >
        </div>
      </div>

      <p-button
        *ngIf="canEdit()"
        [disabled]="isButtonDisabled && !isPermissionConfiguracionOnly"
        icon="pi pi-save"
        label="Guardar"
        class="p-button-raised w-13rem"
        (click)="showDialog()"
      ></p-button>
    </div>
  </div>
</form>
<p-toast position="top-center" key="tc"></p-toast>
<p-dialog
  appendTo="body"
  [style]="{ width: '500px' }"
  [modal]="true"
  [draggable]="false"
  [(visible)]="showConfirmSaveDialog"
  (onHide)="closeDialog()"
>
  <p-header>
    <div
      style="
        justify-content: left;
        flex-direction: row;
        display: flex;
        align-items: left;
      "
    >
      <i
        class="pi pi-exclamation-triangle"
        style="font-size: 2rem; padding-top: 5px"
      ></i>
      <label class="header_title">Confirmar cambios</label>
    </div>
  </p-header>
  <div style="justify-content: left; display: flex; flex-wrap: wrap">
    <span class="mb-2"
      >Los cambios realizados se aplicarán en tu plataforma de casino
      consultada.</span
    >
    <span class="mt-3">¿Deseas continuar?</span>
  </div>
  <p-footer>
    <div *ngIf="!showProgressBar" style="display: flex; justify-content: right">
      <!-- <button type="button" style="width: 40%;" pButton label="" (click)="closeDialog()"></button> -->
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text"
        label="Cancelar"
        (click)="closeDialog()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-check"
        class="p-button-rounded p-button-text"
        label="Guardar y aplicar"
        (click)="save()"
      ></button>
    </div>
    <p-progressBar
      *ngIf="showProgressBar"
      mode="indeterminate"
      [style]="{ height: '4px' }"
    ></p-progressBar>
  </p-footer>
</p-dialog>
